import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-multiple-select',
  templateUrl: './disable-multiple-select.component.html',
  styleUrls: ['./disable-multiple-select.component.css'],
})
export class DisableMultipleSelectComponent {
  @Input() question!: Question;
}
